import {
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Box,
  Chip,
  Pagination,
  Select,
  MenuItem,
  SelectChangeEvent,
  Avatar,
  FabPropsVariantOverrides,
} from "@mui/material";
import { Check, Person } from "@mui/icons-material";
import { IListSubmissionTcc } from "@/api";
import { useUser } from "@/contexts/UserContext";
import { useState } from "react";

interface ContestantListProps {
  contestants: IListSubmissionTcc["data"]["data"];
  onSelect: (user: string) => void;
  itemsPerPage?: number;
}

export default function ContestantList({
  contestants,
  onSelect,
  itemsPerPage = 10,
}: ContestantListProps) {
  const { user } = useUser();
  // const filteredContestants = contestants.filter(
  //   (contestant) => contestant.assigned_judge === 'judge2'
  // );
  const filteredContestants = contestants;
  console.log(123, filteredContestants)
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(filteredContestants.length / itemsPerPage);

  const paginatedContestants = filteredContestants.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Xử lý sự kiện chuyển trang
  const handlePageChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
    setCurrentPage(newPage);
  };
  return (
    <Box>
      <Typography variant="h5" component="h2" gutterBottom>
        Select a Contestant to Score
      </Typography>

      <Grid container spacing={3}>
        {paginatedContestants.length === 0 ? (
          <Box sx={{display: "flex", justifyContent: "center", width: "100%"}}>
            <Typography
              sx={{
                color: "rgb(102, 102, 102)",
                fontSize: "1rem",
                textAlign: "center",
              }}
            >
              No data available
            </Typography>
          </Box>
        ) : (
          <>
            {paginatedContestants.map((contestant) => {
              // const isScored =
              //   contestant.score !== undefined && contestant.score !== null &&
              //   contestant.judges.some((judge) => judge.judge === user?.user_login);
              // const isScored =
              //   contestant.score !== undefined &&
              //   contestant.score !== null &&
              //   contestant.judge.judge !== null;
              // const judges = contestant.judges?.map((judge) => judge.judge) || [];
              const isScored =
                contestant.score !== undefined &&
                contestant.score !== null && 
                contestant.score != 0;

              return (
                <Grid item xs={12} sm={6} md={4} key={contestant.user}>
                  <Card
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      position: "relative",
                      border: isScored ? "2px solid #4caf50" : "none",
                    }}
                  >
                    {isScored && (
                      <Chip
                        icon={<Check />}
                        label="Scored"
                        color="success"
                        sx={{
                          position: "absolute",
                          top: 10,
                          right: 10,
                          zIndex: 1,
                        }}
                      />
                    )}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: 140,
                        bgcolor: "grey.200",
                      }}
                    >
                      <Avatar sx={{ width: 80, height: 80 }}>
                        <Person fontSize="large" />
                      </Avatar>
                    </Box>
                    <CardContent
                      sx={{
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        minHeight: 130, // Đặt chiều cao tối thiểu để đồng nhất các thẻ
                      }}
                    >
                      <Box>
                        <Typography gutterBottom variant="h6" component="div">
                          {contestant.display_name}
                        </Typography>
                        <Typography gutterBottom>
                          {contestant.submitted_count} of{" "}
                          {contestant.total_parts} deliverables completed
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          mt: 1,
                          p: 1,
                          bgcolor: "grey.100",
                          borderRadius: 1,
                        }}
                      >
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100%", // Giới hạn trong phần tử cha
                            display: "block",
                          }}
                        >
                          {/* Scored by: <strong>{judges.join(", ") || ""}</strong> */}
                          Scored by AI: <strong>{contestant.ai_score}</strong>
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100%", // Giới hạn trong phần tử cha
                            display: "block",
                          }}
                        >
                          {/* Scored by: <strong>{judges.join(", ") || ""}</strong> */}
                          Scored by:{" "}
                          <strong>{contestant.judgeInfo.display_name || ""}</strong>
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Score: <strong>{contestant.score ?? ""}</strong>
                        </Typography>
                      </Box>
                      <Button
                        variant="contained"
                        color={isScored ? "secondary" : "primary"}
                        onClick={() => onSelect(contestant.user)}
                        fullWidth
                        sx={{ mt: 2 }}
                      >
                        {isScored ? "Edit Score" : "Score Now"}
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </>
        )}
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          {totalPages > 1 && (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
              />
            </Box>
          )}
      </Box>
    </Box>
  );
}
